import { useLocation } from "react-router-dom";

export function getPanelPath(
  _panelId: number | string | undefined,
  path = "/",
) {
  return path.startsWith("/") ? path : `/${path}`;
}

export function usePanelPath() {
  const location = useLocation();

  return (path = "/") => {
    const normalizedPath = getPanelPath(undefined, path);
    return normalizedPath;
  };
}
